<template>
    <div class="main-nav-item" :class="rootClasses">
        <div class="main-nav-item--wrap">
            <div class="main-nav-item--concentrator"
                    v-on-clickaway="onMenuClickaway"
                    @mouseenter="onMenuHover(true)"
                    @mouseleave="onMenuHover(false)">
                <a :href="child.path" class="u-reset main-nav-item--link"
                        :class="[isShown ? 'main-nav-item--link__has-visible-sub-nav' : '']"
                        @click.prevent="onMenuItemClick($event)">
                    <slot name="link"></slot>
                </a>
                <transition name="trs-menu-fade">
                    <cmp-sub-nav v-if="isShown"
                            class="main-nav-item--sub-nav"
                            facet="base"
                            :is-fixed="isFixed"
                            :child="child">
                    </cmp-sub-nav>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import { debounce } from 'lodash';
    import { touchevents } from 'modernizr';
    import bemMixin from 'vue/mixins/bem';
    import interactiveNavItemMixin from 'vue/mixins/interactive-nav-item';
    import { mixin as clickawayMixin } from 'vue-clickaway';


    export default {
        mixins: [
            bemMixin('main-nav-item'),
            interactiveNavItemMixin,
            clickawayMixin,
        ],
        props: {
            showSubNav: {
                type: Boolean,
                default: true,
            },
            isFixed: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                hasFlyout: false,
            };
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemIf(!this.showSubNav, 'no-sub-nav'),
                ];
            },
        },
        methods: {
            debouncedUpdateNav: debounce(function(toggle) {
                if (toggle) {
                    this.updateNav(toggle);
                } else {
                    this.resetNavigation();
                }
            }, 200),
            onMenuHover(toggle) {
                if (touchevents) {
                    return;
                }

                this.debouncedUpdateNav(toggle);
            },
            onMenuClickaway() {
                this.resetNavigation();
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?1df49ddc